import { ButtonLink } from './button';
import List from './list';

export const Related = ({
  title,
  text = '',
  items,
  btnLink,
  btnText,
  className = '',
}) => {
  return (
    <div className={`relative px-6 lg:px-8 ${className}`}>
      <div className={`mx-auto max-w-6xl`}>
        {items.length > 0 && (
          <>
            <h2 className='h1'>{title}</h2>
            {text && (
              <p
                className='mt-4'
                dangerouslySetInnerHTML={{
                  __html: text,
                }}
              />
            )}
            <List className='mt-10' items={items} listName='related' />

            <ButtonLink className='relative z-10 mt-8 max-w-md' href={btnLink}>
              {btnText}
            </ButtonLink>
          </>
        )}
      </div>
    </div>
  );
};
